import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { ROLES } from 'src/services/mappings/relation/relation.const'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const relationFields: FieldInterface[] = [
  {
    key: 'role',
    originKey: 'role',
    type: FIELD_TYPES.string,
    enumKeys: Object.values(ROLES),
    objectType: 'Role',
    objectTypePath: 'src/services/mappings/relation/relation.const',
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'inverseRole',
    originKey: 'inverse_role',
    type: FIELD_TYPES.string,
    enumKeys: Object.values(ROLES),
    objectType: 'Role',
    objectTypePath: 'src/services/mappings/relation/relation.const',
    rule: FIELD_RULES.isOptional,
  },
]

const relationRelations: RelationInterface[] = [
  {
    key: '_subject',
    originKey: 'subject',
    objectType: OBJECT_TYPES.person,
    isMultiple: false,
  },
  {
    key: '_relatedTo',
    originKey: 'related_to',
    objectType: OBJECT_TYPES.person,
    isMultiple: false,
  },
]

export { relationFields, relationRelations }
